import { render, staticRenderFns } from "./SearchNoResults.vue?vue&type=template&id=499437e6"
import script from "./SearchNoResults.vue?vue&type=script&lang=js"
export * from "./SearchNoResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports